export const CLEAR_SUCCESS = "CLEAR_SUCCESS"
export const SET_COMPONENTS_LOADING = "SET_COMPONENTS_LOADING"
export const SET_PANEL_LOADING = "SET_PANEL_LOADING"

export const successClear = () => ({ type: CLEAR_SUCCESS })
export const setComponentLoading = () => ({ type: SET_COMPONENTS_LOADING })
export const setPanelLoading = () => ({ type: SET_PANEL_LOADING })
